function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import { Link } from '../Link/Link';
import styles from './BypassBlock.module.less';
export var BypassBlock = function BypassBlock(_ref) {
  var className = _ref.className,
      dangerouslyForceVisible = _ref.dangerouslyForceVisible,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Skip to content' : _ref$label,
      _ref$targetId = _ref.targetId,
      targetId = _ref$targetId === void 0 ? 'main' : _ref$targetId;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.container, className, _defineProperty({}, styles.forceVisible, dangerouslyForceVisible))
  }, /*#__PURE__*/React.createElement(Link, {
    href: "#".concat(targetId),
    bold: true
  }, label));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  var PropTypes = require('prop-types');

  BypassBlock.propTypes = {
    /**
     * Additional classes to be added to the containing element.
     */
    className: PropTypes.string,

    /**
     * Forces the bypass block to be visible, even if it doesn't have focus.
     * Can be useful for testing layout, but it should NOT be used in production.
     */
    dangerouslyForceVisible: PropTypes.bool,

    /**
     * The label for the bypass block; this should describe where the user will skip to.
     */
    label: PropTypes.string,

    /**
     * The ID of the element that this bypass block should skip to.
     */
    targetId: PropTypes.string
  };
}